"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleNotificationsRequest = exports.closeNotificationsOptionsPaneAction = exports.openNotificationsOptionsPaneAction = exports.resetSortOptionsAction = exports.resetSearchOptionsAction = exports.metadataUpdateSuccess = exports.unbookmarkFileSuccess = exports.unbookmarkFileFailure = exports.unbookmarkFile = exports.bookmarkFileSuccess = exports.bookmarkFileFailure = exports.bookmarkFile = exports.quickSearchFilesFailure = exports.quickSearchFilesSuccess = exports.quickSearchFilesRequest = exports.limitSearchFolderId = exports.toggleMobileSearchOverlayAction = exports.toggleSortDropdownAction = exports.toggleAdvancedSearchDropdownAction = exports.toggleSearchDropdownAction = exports.toggleColumnsDropdownAction = exports.toggleFiltersDropdownAction = exports.toggleMoreSearch = exports.setSearchFileTypeAction = exports.clearAllColumnFiltersAction = exports.clearColumnFilterAction = exports.setColumnFilterStringAction = exports.setSearchStringAction = exports.toggleHideEmptyFolders = exports.toggleAllMetadataColumnsSuccess = exports.toggleAllMetadataColumns = exports.toggleRecents = exports.toggleShowBookmarksOff = exports.toggleShowBookmarks = exports.unselectFileItems = exports.selectFileItems = exports.fetchFilesFailure = exports.fetchFilesSuccess = exports.fetchFiles = exports.fetchSchemaFailure = exports.fetchSchemaSuccess = exports.fetchSchema = exports.FileBrowserActions = exports.PreviewActions = exports.PropertiesActions = exports.ImportFromProjectActions = exports.FolderTreeActions = exports.ListQuicksearchActions = exports.ListActions = exports.MetaActions = void 0;
exports.collapseAll = exports.initFolderTree = exports.removeItemsFromTree = exports.getProjectFilelistWidthFailure = exports.getProjectFilelistWidthSuccess = exports.getFilelistWidthRequestAction = exports.setFilelistWidth = exports.saveProjectFilelistWidthFailure = exports.saveProjectFilelistWidthSuccess = exports.saveFilelistWidthRequestAction = exports.importSetStep = exports.importSetGroup = exports.importFetchGroupListFailure = exports.importFetchGroupListSuccess = exports.importFetchGroupListRequest = exports.importSetProject = exports.importFetchProjectListFailure = exports.importFetchProjectListSuccess = exports.importFetchProjectListRequest = exports.importClear = exports.setPagingOptions = exports.setHideEmptyFolders = exports.setFilteringType = exports.generatePreviewSuccess = exports.generatePreviewFailure = exports.generatePreviewRequest = exports.toggleFileReportSelection = exports.toggleFileReportModal = exports.clear = exports.refreshFiles = exports.clearSortByOptions = exports.setPreviewFullScreenEnabled = exports.setContainsTermStringAction = exports.fetchFileListColumnsSuccess = exports.fetchFileListColumnsFailure = exports.fetchFileListColumns = exports.resetSelectedFolders = exports.setComparisionOpacity = exports.setSelectedView = exports.compareFileRevisions = exports.previewFileRevision = exports.SetPreviewFileDropdownAction = exports.TogglePreviewFileDropdownAction = exports.fetchRevisionFailure = exports.fetchRevisionSuccess = exports.fetchRevision = exports.setPreviewRevision = exports.toggleNotificationsSuccess = exports.toggleNotificationsFailure = exports.updateFolderNotifications = void 0;
exports.fileBrowserFetchItemsFailure = exports.fileBrowserFetchItemsSuccess = exports.fileBrowserFetchItemsRequest = void 0;
const ActionTypes = require("../../actionTypes/files");
const _MetaActions = require("../../modules/metaschema/actions");
const _ListActions = require("../../modules/files/list/actions");
const _FolderTreeActions = require("../../modules/files/tree/actions");
const _PropertiesActions = require("../../modules/files/crud/actions");
const _PreviewActions = require("../../modules/files/preview/actions");
exports.MetaActions = _MetaActions.default('files');
exports.ListActions = _ListActions.default('files');
exports.ListQuicksearchActions = _ListActions.default('files-quicksearch');
exports.FolderTreeActions = _FolderTreeActions.default('files');
exports.ImportFromProjectActions = _FolderTreeActions.default('import');
exports.PropertiesActions = _PropertiesActions.default('files');
exports.PreviewActions = _PreviewActions.default('files');
exports.FileBrowserActions = _FolderTreeActions.default('browser');
exports.fetchSchema = exports.MetaActions.fetchSchema;
exports.fetchSchemaSuccess = exports.MetaActions.fetchSchemaSuccess;
exports.fetchSchemaFailure = exports.MetaActions.fetchSchemaFailure;
exports.fetchFiles = exports.ListActions.fetchRequest;
exports.fetchFilesSuccess = exports.ListActions.fetchSuccess;
exports.fetchFilesFailure = exports.ListActions.fetchFailure;
function selectFileItems(items) {
    return {
        type: ActionTypes.SELECT_ITEMS,
        data: {
            items
        }
    };
}
exports.selectFileItems = selectFileItems;
function unselectFileItems(items) {
    return {
        type: ActionTypes.UNSELECT_ITEMS,
        data: {
            items
        }
    };
}
exports.unselectFileItems = unselectFileItems;
function toggleShowBookmarks() {
    return {
        type: ActionTypes.TOGGLE_SHOW_BOOKMARKS
    };
}
exports.toggleShowBookmarks = toggleShowBookmarks;
function toggleShowBookmarksOff() {
    return {
        type: ActionTypes.TOGGLE_SHOW_BOOKMARKS_OFF
    };
}
exports.toggleShowBookmarksOff = toggleShowBookmarksOff;
function toggleRecents() {
    return {
        type: ActionTypes.TOGGLE_RECENTS
    };
}
exports.toggleRecents = toggleRecents;
function toggleAllMetadataColumns(metadatas, selected, projectId) {
    return {
        type: ActionTypes.TOGGLE_ALL_METADATA_COLUMNS,
        payload: {
            metadatas,
            selected,
            projectId
        }
    };
}
exports.toggleAllMetadataColumns = toggleAllMetadataColumns;
function toggleAllMetadataColumnsSuccess(metadatas) {
    return {
        type: ActionTypes.TOGGLE_ALL_METADATA_COLUMNS_SUCCESS,
        payload: {
            metadatas
        }
    };
}
exports.toggleAllMetadataColumnsSuccess = toggleAllMetadataColumnsSuccess;
function toggleHideEmptyFolders() {
    return {
        type: ActionTypes.TOGGLE_HIDE_EMPTY_FOLDERS
    };
}
exports.toggleHideEmptyFolders = toggleHideEmptyFolders;
function setSearchStringAction(searchString) {
    return {
        type: ActionTypes.SET_SEARCH_STRING,
        payload: {
            searchString
        }
    };
}
exports.setSearchStringAction = setSearchStringAction;
function setColumnFilterStringAction(columnValue, columnId) {
    return {
        type: ActionTypes.SET_COLUMN_FILTER_STRING,
        payload: {
            columnValue: columnValue,
            columnId: columnId
        }
    };
}
exports.setColumnFilterStringAction = setColumnFilterStringAction;
function clearColumnFilterAction(columnId) {
    return {
        type: ActionTypes.CLEAR_COLUMN_FILTER,
        columnId
    };
}
exports.clearColumnFilterAction = clearColumnFilterAction;
function clearAllColumnFiltersAction() {
    return {
        type: ActionTypes.CLEAR_ALL_COLUMN_FILTERS
    };
}
exports.clearAllColumnFiltersAction = clearAllColumnFiltersAction;
function setSearchFileTypeAction(searchFileType) {
    return {
        type: ActionTypes.SET_SEARCH_FILETYPE,
        payload: {
            searchFileType
        }
    };
}
exports.setSearchFileTypeAction = setSearchFileTypeAction;
function toggleMoreSearch(status) {
    return {
        type: ActionTypes.TOGGLE_MORE_SEARCH,
        payload: status
    };
}
exports.toggleMoreSearch = toggleMoreSearch;
function toggleFiltersDropdownAction() {
    return {
        type: ActionTypes.TOGGLE_FILTERS_DROPDOWN
    };
}
exports.toggleFiltersDropdownAction = toggleFiltersDropdownAction;
function toggleColumnsDropdownAction() {
    return {
        type: ActionTypes.TOGGLE_COLUMNS_DROPDOWN
    };
}
exports.toggleColumnsDropdownAction = toggleColumnsDropdownAction;
function toggleSearchDropdownAction() {
    return {
        type: ActionTypes.TOGGLE_SEARCH_DROPDOWN
    };
}
exports.toggleSearchDropdownAction = toggleSearchDropdownAction;
function toggleAdvancedSearchDropdownAction() {
    return {
        type: ActionTypes.TOGGLE_ADVANCED_SEARCH_DROPDOWN
    };
}
exports.toggleAdvancedSearchDropdownAction = toggleAdvancedSearchDropdownAction;
function toggleSortDropdownAction() {
    return {
        type: ActionTypes.TOGGLE_SORT_DROPDOWN
    };
}
exports.toggleSortDropdownAction = toggleSortDropdownAction;
function toggleMobileSearchOverlayAction() {
    return {
        type: ActionTypes.TOGGLE_MOBILE_SEARCH_OVERLAY
    };
}
exports.toggleMobileSearchOverlayAction = toggleMobileSearchOverlayAction;
function limitSearchFolderId(payload) {
    return {
        type: ActionTypes.LIMIT_SEARCH_FOLDER_ID,
        payload
    };
}
exports.limitSearchFolderId = limitSearchFolderId;
exports.quickSearchFilesRequest = exports.ListQuicksearchActions.fetchRequest;
exports.quickSearchFilesSuccess = exports.ListQuicksearchActions.fetchSuccess;
exports.quickSearchFilesFailure = exports.ListQuicksearchActions.fetchFailure;
function bookmarkFile(data) {
    return {
        type: ActionTypes.BOOKMARK_FILE_REQUEST,
        payload: {
            id: data,
            bookmarked: true
        }
    };
}
exports.bookmarkFile = bookmarkFile;
function bookmarkFileFailure(error) {
    return {
        type: ActionTypes.BOOKMARK_FILE_FAILURE,
        payload: error
    };
}
exports.bookmarkFileFailure = bookmarkFileFailure;
function bookmarkFileSuccess(data) {
    return {
        type: ActionTypes.BOOKMARK_FILE_SUCCESS,
        result: data
    };
}
exports.bookmarkFileSuccess = bookmarkFileSuccess;
function unbookmarkFile(data) {
    return {
        type: ActionTypes.UNBOOKMARK_FILE_REQUEST,
        payload: {
            id: data,
            bookmarked: false
        }
    };
}
exports.unbookmarkFile = unbookmarkFile;
function unbookmarkFileFailure(error) {
    return {
        type: ActionTypes.UNBOOKMARK_FILE_FAILURE,
        payload: error
    };
}
exports.unbookmarkFileFailure = unbookmarkFileFailure;
function unbookmarkFileSuccess(data) {
    return {
        type: ActionTypes.UNBOOKMARK_FILE_SUCCESS,
        result: data
    };
}
exports.unbookmarkFileSuccess = unbookmarkFileSuccess;
function metadataUpdateSuccess() {
    return { type: ActionTypes.METADATA_UPDATE_SUCCESS };
}
exports.metadataUpdateSuccess = metadataUpdateSuccess;
function resetSearchOptionsAction() {
    return {
        type: ActionTypes.RESET_SEARCH_OPTIONS
    };
}
exports.resetSearchOptionsAction = resetSearchOptionsAction;
function resetSortOptionsAction() {
    return {
        type: ActionTypes.RESET_SORT_OPTIONS
    };
}
exports.resetSortOptionsAction = resetSortOptionsAction;
function openNotificationsOptionsPaneAction(files, projectName) {
    return {
        type: ActionTypes.OPEN_NOTIFICATIONS_OPTIONS_PANE,
        payload: {
            files,
            projectName
        }
    };
}
exports.openNotificationsOptionsPaneAction = openNotificationsOptionsPaneAction;
function closeNotificationsOptionsPaneAction() {
    return {
        type: ActionTypes.CLOSE_NOTIFICATIONS_OPTIONS_PANE
    };
}
exports.closeNotificationsOptionsPaneAction = closeNotificationsOptionsPaneAction;
function toggleNotificationsRequest(files, status, notificationType) {
    return {
        type: ActionTypes.TOGGLE_NOTIFICATIONS_REQUEST,
        payload: {
            files,
            status,
            notificationType
        }
    };
}
exports.toggleNotificationsRequest = toggleNotificationsRequest;
function updateFolderNotifications(files, state) {
    return {
        type: ActionTypes.UPDATE_FOLDER_NOTIFICATIONS,
        payload: {
            files,
            state
        }
    };
}
exports.updateFolderNotifications = updateFolderNotifications;
function toggleNotificationsFailure(error) {
    return {
        type: ActionTypes.TOGGLE_NOTIFICATIONS_FAILURE,
        payload: error
    };
}
exports.toggleNotificationsFailure = toggleNotificationsFailure;
function toggleNotificationsSuccess() {
    return {
        type: ActionTypes.TOGGLE_NOTIFICATIONS_SUCCESS
    };
}
exports.toggleNotificationsSuccess = toggleNotificationsSuccess;
exports.setPreviewRevision = exports.PreviewActions.setPreviewRevision;
function fetchRevision(revisionUuid) {
    return {
        type: ActionTypes.FETCH_REVISION_REQUEST,
        payload: {
            revisionUuid
        }
    };
}
exports.fetchRevision = fetchRevision;
function fetchRevisionSuccess(payload) {
    return {
        type: ActionTypes.FETCH_REVISION_SUCCESS,
        payload
    };
}
exports.fetchRevisionSuccess = fetchRevisionSuccess;
function fetchRevisionFailure(payload) {
    return {
        type: ActionTypes.FETCH_REVISION_FAILURE,
        payload
    };
}
exports.fetchRevisionFailure = fetchRevisionFailure;
function TogglePreviewFileDropdownAction() {
    return {
        type: ActionTypes.TOGGLE_PREVIEW_FILE_DROPDOWN
    };
}
exports.TogglePreviewFileDropdownAction = TogglePreviewFileDropdownAction;
function SetPreviewFileDropdownAction(flag) {
    return {
        type: ActionTypes.SET_PREVIEW_FILE_DROPDOWN,
        flag
    };
}
exports.SetPreviewFileDropdownAction = SetPreviewFileDropdownAction;
function previewFileRevision(revision) {
    return {
        type: ActionTypes.PREVIEW_FILE_REVISION,
        revision
    };
}
exports.previewFileRevision = previewFileRevision;
function compareFileRevisions(revision, comparedRevision) {
    return {
        type: ActionTypes.COMPARE_FILE_REVISIONS,
        revision,
        comparedRevision
    };
}
exports.compareFileRevisions = compareFileRevisions;
function setSelectedView(view) {
    return {
        type: ActionTypes.SELECT_VIEW,
        view
    };
}
exports.setSelectedView = setSelectedView;
function setComparisionOpacity(opacity) {
    return {
        type: ActionTypes.SET_COMPARISION_OPACITY,
        opacity
    };
}
exports.setComparisionOpacity = setComparisionOpacity;
function resetSelectedFolders() {
    return {
        type: ActionTypes.RESET_SELECTED_FOLDERS
    };
}
exports.resetSelectedFolders = resetSelectedFolders;
function fetchFileListColumns(projectId) {
    return {
        type: ActionTypes.FETCH_FILELIST_COLUMNS,
        projectId
    };
}
exports.fetchFileListColumns = fetchFileListColumns;
function fetchFileListColumnsFailure(error) {
    return {
        type: ActionTypes.FETCH_FILELIST_COLUMNS_FAILURE,
        payload: error
    };
}
exports.fetchFileListColumnsFailure = fetchFileListColumnsFailure;
function fetchFileListColumnsSuccess(metadatas) {
    return {
        type: ActionTypes.FETCH_FILELIST_COLUMNS_SUCCESS,
        metadatas
    };
}
exports.fetchFileListColumnsSuccess = fetchFileListColumnsSuccess;
function setContainsTermStringAction(containsTermString) {
    return {
        type: ActionTypes.SET_CONTAINSTERM_STRING,
        payload: {
            containsTermString
        }
    };
}
exports.setContainsTermStringAction = setContainsTermStringAction;
function setPreviewFullScreenEnabled(enabled) {
    return {
        type: ActionTypes.SET_PREVIEW_FULL_SCREEN_ENABLED,
        enabled
    };
}
exports.setPreviewFullScreenEnabled = setPreviewFullScreenEnabled;
function clearSortByOptions() {
    return {
        type: ActionTypes.CLEAR_SORT_BY_OPTIONS
    };
}
exports.clearSortByOptions = clearSortByOptions;
function refreshFiles() {
    return {
        type: ActionTypes.REFRESH_FILES
    };
}
exports.refreshFiles = refreshFiles;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
function toggleFileReportModal() {
    return {
        type: ActionTypes.TOGGLE_FILE_REPORT_MODAL
    };
}
exports.toggleFileReportModal = toggleFileReportModal;
function toggleFileReportSelection() {
    return {
        type: ActionTypes.TOGGLE_FILE_REPORT_SELECTION
    };
}
exports.toggleFileReportSelection = toggleFileReportSelection;
exports.generatePreviewRequest = exports.PreviewActions.generatePreviewRequest;
exports.generatePreviewFailure = exports.PreviewActions.generatePreviewFailure;
exports.generatePreviewSuccess = exports.PreviewActions.generatePreviewSuccess;
function setFilteringType(filtering) {
    return {
        type: ActionTypes.SET_FILTERING_TYPE,
        filtering
    };
}
exports.setFilteringType = setFilteringType;
function setHideEmptyFolders(value) {
    return {
        type: ActionTypes.SET_HIDE_EMPTY_FOLDERS,
        payload: {
            value
        }
    };
}
exports.setHideEmptyFolders = setHideEmptyFolders;
function setPagingOptions(payload) {
    return {
        type: ActionTypes.SET_PAGING_OPTIONS,
        payload
    };
}
exports.setPagingOptions = setPagingOptions;
function importClear() {
    return {
        type: ActionTypes.IMPORT_CLEAR
    };
}
exports.importClear = importClear;
function importFetchProjectListRequest() {
    return {
        type: ActionTypes.IMPORT_FETCH_PROJECT_LIST_REQUEST
    };
}
exports.importFetchProjectListRequest = importFetchProjectListRequest;
function importFetchProjectListSuccess(projects) {
    return {
        type: ActionTypes.IMPORT_FETCH_PROJECT_LIST_SUCCESS,
        data: projects
    };
}
exports.importFetchProjectListSuccess = importFetchProjectListSuccess;
function importFetchProjectListFailure() {
    return {
        type: ActionTypes.IMPORT_FETCH_PROJECT_LIST_FAILURE
    };
}
exports.importFetchProjectListFailure = importFetchProjectListFailure;
function importSetProject(project) {
    return {
        type: ActionTypes.IMPORT_SET_PROJECT,
        data: project
    };
}
exports.importSetProject = importSetProject;
function importFetchGroupListRequest(project) {
    return {
        type: ActionTypes.IMPORT_FETCH_GROUP_LIST_REQUEST,
        payload: project
    };
}
exports.importFetchGroupListRequest = importFetchGroupListRequest;
function importFetchGroupListSuccess(groups) {
    return {
        type: ActionTypes.IMPORT_FETCH_GROUP_LIST_SUCCESS,
        data: groups
    };
}
exports.importFetchGroupListSuccess = importFetchGroupListSuccess;
function importFetchGroupListFailure() {
    return {
        type: ActionTypes.IMPORT_FETCH_GROUP_LIST_FAILURE
    };
}
exports.importFetchGroupListFailure = importFetchGroupListFailure;
function importSetGroup(group) {
    return {
        type: ActionTypes.IMPORT_SET_GROUP,
        data: group
    };
}
exports.importSetGroup = importSetGroup;
function importSetStep(step) {
    return {
        type: ActionTypes.IMPORT_SET_STEP,
        data: step
    };
}
exports.importSetStep = importSetStep;
function saveFilelistWidthRequestAction(projectId, width, status) {
    return {
        type: ActionTypes.SAVE_FILELIST_WIDTH_REQUEST,
        payload: {
            projectId,
            width,
            status
        }
    };
}
exports.saveFilelistWidthRequestAction = saveFilelistWidthRequestAction;
function saveProjectFilelistWidthSuccess() {
    return {
        type: ActionTypes.SAVE_FILELIST_WIDTH_SUCCESS
    };
}
exports.saveProjectFilelistWidthSuccess = saveProjectFilelistWidthSuccess;
function saveProjectFilelistWidthFailure(error) {
    return {
        type: ActionTypes.SAVE_FILELIST_WIDTH_FAILURE,
        payload: error
    };
}
exports.saveProjectFilelistWidthFailure = saveProjectFilelistWidthFailure;
function setFilelistWidth(width, status) {
    return {
        type: ActionTypes.SET_FILELIST_WIDTH,
        payload: {
            width,
            status
        }
    };
}
exports.setFilelistWidth = setFilelistWidth;
function getFilelistWidthRequestAction(projectId) {
    return {
        type: ActionTypes.GET_FILELIST_WIDTH,
        payload: {
            projectId
        }
    };
}
exports.getFilelistWidthRequestAction = getFilelistWidthRequestAction;
function getProjectFilelistWidthSuccess(width, status) {
    return {
        type: ActionTypes.GET_FILELIST_WIDTH_SUCCESS,
        data: {
            width,
            status
        }
    };
}
exports.getProjectFilelistWidthSuccess = getProjectFilelistWidthSuccess;
function getProjectFilelistWidthFailure(error) {
    return {
        type: ActionTypes.GET_FILELIST_WIDTH_FAILURE,
        payload: error
    };
}
exports.getProjectFilelistWidthFailure = getProjectFilelistWidthFailure;
function removeItemsFromTree(files) {
    return {
        type: ActionTypes.REMOVE_ITEMS_FROM_TREE,
        data: {
            files: files
        }
    };
}
exports.removeItemsFromTree = removeItemsFromTree;
function initFolderTree(useFolderTree, node) {
    if (useFolderTree && node) {
        return {
            type: ActionTypes.INIT_FOLDER_TREE,
            payload: { useFolderTree: true, node }
        };
    }
    return {
        type: ActionTypes.INIT_FOLDER_TREE,
        payload: { useFolderTree: false }
    };
}
exports.initFolderTree = initFolderTree;
function collapseAll() {
    return {
        type: ActionTypes.COLLAPSE_ALL
    };
}
exports.collapseAll = collapseAll;
function fileBrowserFetchItemsRequest(path) {
    return {
        type: ActionTypes.FILE_BROWSER_FETCH_ITEMS_REQUEST,
        payload: path
    };
}
exports.fileBrowserFetchItemsRequest = fileBrowserFetchItemsRequest;
function fileBrowserFetchItemsSuccess(files) {
    return {
        type: ActionTypes.FILE_BROWSER_FETCH_ITEMS_SUCCESS,
        payload: files
    };
}
exports.fileBrowserFetchItemsSuccess = fileBrowserFetchItemsSuccess;
function fileBrowserFetchItemsFailure(error, path) {
    return {
        type: ActionTypes.FILE_BROWSER_FETCH_ITEMS_FAILURE,
        payload: error,
        path
    };
}
exports.fileBrowserFetchItemsFailure = fileBrowserFetchItemsFailure;
__exportStar(require("./automaticFileConversion"), exports);
//# sourceMappingURL=index.js.map